import { useEmailActivation } from "@state/hooks/membership/email-activation";
import React, { useEffect } from "react";
import { ActivationSuccess, ActivationError, ActivationInProgress } from ".";
import { setTabTitle } from "@utils";
import { useScrollRestoration } from "@hooks/useScrollRestoration";
import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";
import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";

/** 
	This component is used for "Email change" action from account settings on website (we send URL to API where should link from mail lead) for online and retail user and after user card (retail user) is activated.
	API endpoint: platform/agency-users/email-change
*/
export default function EmailActivationPage() {
	const { activateUserEmail, activationState, errorMessage } =
		useEmailActivation();

	useScrollRestoration({ type: ConfigType.Basic });

	useEffect(() => {
		setTabTitle("Email activation");

		activateUserEmail();
	}, []);

	return (
		<DesktopLayout>
			<section className="l--content l--content--full">
				<div className="l--content__main">
					{/* success */}
					<ActivationSuccess activationState={activationState} />

					{/* errorr */}
					<ActivationError
						activationState={activationState}
						errorMessage={errorMessage}
					/>

					{/* ostalo : waiting... */}
					<ActivationInProgress />
				</div>
			</section>
		</DesktopLayout>
	);
}
